import 'slick-carousel';
/**
 * Initialize collection slider
 * @param  {String} slider - Collection slider selector
 * @return {Void}
 */

export const collectionSlider = (slider = '.js-slider-collection') => {
  const config = {
  slidesToShow: 4,
    slidesToScroll: 4,
    dots: false,
    arrows: true,
    infinite: false,
    focusOnSelect: true,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      }
    }],
  };

  setInterval(() => {
    $(slider)
      .not('.slick-initialized').each(function () {
        $(this).slick(config);
      })
  }, 1000);
};

collectionSlider();

$(window).on('shopify:section:load', function (event) {
  collectionSlider();
});
